import { gql } from '@apollo/client'

export const CHECK_USER_PASSWORD = gql`
  mutation CheckPassword($inputData: ChangePasswordInput!) {
    checkPassword(inputData: $inputData)
  }
`
